"use strict";var e;Object.defineProperty(exports,"__esModule",{value:!0}),exports.FontWeight=void 0,(e=exports.FontWeight||(exports.FontWeight={}))[e.regular=200]="regular",e[e.medium=400]="medium",e[e.semibold=600]="semibold",e[e.bold=700]="bold",e[e.black=800]="black";
//# sourceMappingURL=types.js.map
